import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import { Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { useIntl } from 'react-intl-next';

import messages from './messages';

const boxStyles = xcss({
	borderStyle: 'solid',
	borderRadius: 'border.radius.200',
	borderColor: 'color.border',
	borderWidth: 'border.width.outline',
	padding: 'space.200',
});
const listStyles = css({ paddingLeft: token('space.250') });
const listItemStyles = css({ marginBottom: token('space.100') });

export const UsingCodeReviewer = () => {
	const { formatMessage } = useIntl();

	return (
		<Stack xcss={boxStyles} space="space.200">
			<Heading size="small">{formatMessage(messages.usingCodeReviewerTitle)}</Heading>
			<Stack>
				<Text>
					{formatMessage(messages.usingCodeReviewerIntro)}{' '}
					<Link href="https://rovodevagents-beta.atlassian.net/wiki/external/YWJmZmRiNTFhYTUxNDBhOTg5ZjY5ZmQ0Yzg5MTlkNzA">
						{formatMessage(messages.usingCodeReviewerReadMore)}
					</Link>
				</Text>
				<ul css={listStyles}>
					<li css={listItemStyles}>{formatMessage(messages.usingCodeReviewerLimitInfo)}</li>
					<li css={listItemStyles}>
						{formatMessage(messages.usingCodeReviewerLanguagesInfo)}{' '}
						<Link href="https://rovodevagents-beta.atlassian.net/wiki/external/MmVjYmFiNzA1NjQ0NGZjODg5NTBhMGM3OTQyYTQ4MmY">
							{formatMessage(messages.usingCodeReviewerLanguagesLink)}
						</Link>
					</li>
				</ul>
			</Stack>
		</Stack>
	);
};
